/**
 * randomPot — the Random Pot's presentation spin (GDD "Random Pot — Hold & Win
 * Activation").
 *
 * The server awards Hold & Win through the Pot on an ordinary paid spin: its
 * board has no coins; the bonus's starting coins come in bonus_data. The GDD
 * then plays a PRESENTATION-ONLY spin: "Start a presentation-only reel spin …
 * No additional bet is deducted", the logo covering the reels for ~1–2 s, the
 * reels stopping on the awarded coins, and Hold & Win from there.
 *
 * That spin runs through the ordinary spin path (handleSpin -> rgsPlay) so the
 * reels, the landing and the win presentation are the real ones — but rgsPlay
 * sends NOTHING for it: the provider answers from the trigger response it kept
 * (RGS.randomPotPresentation), with only the board replaced. Its answer waits
 * for the logo's flight over the reels (the gate below), so the reels stop
 * once the logo has flown back.
 */

let gate = null;

/** The flight begins: returns the function that ends it. */
export const beginRandomPotFlight = () => {
  let release;
  const done = new Promise((resolve) => {
    release = resolve;
  });
  gate = { done, release };
  return () => {
    release();
    if (gate?.done === done) gate = null;
  };
};

/** Resolves when the current flight has ended (at once when there is none). */
export const randomPotFlightDone = () => gate?.done ?? Promise.resolve();
